import Vue from "vue";
import VueMask from "v-mask";

Vue.use(VueMask);

export default {
  DATE: "##/##/####",
  TIME: "##:##",
  CARD_NUMBER: "#### #### #### ####",
  CARD_EXPIRY_DATE: "##/##",
  CARD_SECURITY_CODE: "###?",
  CELLPHONE: "(##) #####-####",
  PHONE: "(##) ####-####",
  CNPJ: "NN.NNN.NNN/NNNN-##",
  ZIPCODE: "##.###-###",
  CPF: "###.###.###-##",
};
